import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);

export const CustomerProvider = ({ children }) => {
  const [customer, setCustomer] = useState(null);
  const refresh = useCallback(() => api.get("/account/me").then((r) => setCustomer(r.data)).catch(() => setCustomer(false)), []);
  useEffect(() => {
    if (window.location.hash.includes("session_id=")) return; // GoogleCallback sets the customer
    refresh();
  }, [refresh]);
  const logout = async () => { await api.post("/account/logout").catch(() => {}); setCustomer(false); };
  return <Ctx.Provider value={{ customer, setCustomer, refresh, logout }}>{children}</Ctx.Provider>;
};

export const useCustomer = () => useContext(Ctx);
